<!--
/**
  * 选项卡组件
  * @author weili
  * @date 2023-05-24
  使用说明：
    tabs  选项卡名称集合
    currentTab  当前选中的名称
    checkTabFn  选中时调用的父组件方法
    showDivider(true|*false) 是否显示顶部横条
    cssStyle 自定义文字样式
    align(*left|right) 设置选项卡对齐方式
  */
-->
<template>
  <div>
    <div v-show="showDivider" class="divider">
        <div
            style="
            width: calc(100% - 0.2rem - 0.2rem);
            height: 100%;
            margin: 0 auto;
            background: #d9d9d9;
            "
          ></div>
      </div>
    <div :class="['tabs-box',align=='right'?'right':'']">
      <div
        :style="cssStyle"
        :class="['title',currentTab == title ?'currentTab':'tab']"
        v-for="(title, index) in tabs"
        :key="index"
        @click="handleEvent(title)"
      >
        {{ title }}
      </div>
  </div>
</div>
</template>

<script>
export default {
 name: 'EXTabs',
 props: {
   tabs: {
     type: Array,
     default: [],
   },
   currentTab: String,
   checkTabFn: {
     type: Function,
   },
   showDivider: {
     type: Boolean,
     default: false
   },
   cssStyle:String,
   align: {
      type: String,
      default: 'left' 
   }
 },
 methods: {
  handleEvent(title) {
     this.$emit("checkTabFn", title);
   },
 },
};
</script>

<style lang="scss" scoped>
@import '../../styles/variables.scss';
.divider {
    width: 100%;
    height: 0.01rem;
    background: #fff;
  }
.tabs-box {
 display: flex;
 padding-left: 0.2rem;
 margin-top: 0.2rem;
//  margin-bottom: 0.1rem;
 .title {
   color: #333;
   margin-right: 0.2rem;
   padding-bottom: 0.1rem;
   text-align: center;
   min-width: 1rem;
   &:hover {
     cursor: pointer;
     @include tab_border_color($tab-borderD);
   }
 }
 .currentTab{
  @include tab_border_color($tab-borderD);
 }
 .tab{
  color: #333;
  border-bottom: none;
}
}
.right{
  margin-top: 0.1rem !important;
   justify-content:flex-end;
 }
</style>


// WEBPACK FOOTER //
// src/components/EXTabs/index.vue